export async function fetchOrderData(
  orderId: string | null,
  email: string | null,
) {
  const url = "https://culture-circle.azurewebsites.net/graphql";
  const payload = {
    operationName: "TrackOrder",
    variables: {
      orderId: orderId,
      email: email,
      phone: null,
    },
    query: `query TrackOrder($orderId: String!, $phone: String, $email: String) {
            trackMyOrders(orderId: $orderId, phone: $phone, email: $email) {
                edges {
                    node {
                        masterOrder {
                            address
                            city
                            email
                            id
                            name
                            createdAt
                            pincode
                            phone
                            state
                            isPaid
                            isPartialPayment
                            paymentPlatform
                            paymentPlatformId
                        }
                        status
                        variant {
                            title
                            product {
                                brandName
                                title
                                slug
                                createdAt
                                images(first: 1) {
                                    edges {
                                        node {
                                            image
                                            thumbnail
                                        }
                                    }
                                }
                            }
                        }
                        amount
                        trackingUrl
                        trackingId
                        shippingPlatform
                        shipsByDate
                        isEscalated
                        remarks
                    }
                }
            }
        }`,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching order data:", error);
    return null;
  }
}


export function extractSlugs(orderData) {
    return orderData?.trackMyOrders?.edges?.map(edge => edge.node?.variant?.product?.slug).filter(slug => slug) || [];
}